import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link } from 'gatsby'
import classNames from 'classnames'
import * as styles from '../../styles/layout/nav.module.scss'

class MenuItem extends Component {
  constructor (props) {
    super(props)

    this.ref = React.createRef()
    this.subnavRef = React.createRef()

    this.state = {
      rect: {}
    }
  }

  render () {
    return (
      <li
        key={this.props.item.id}
        onMouseEnter={this.props.onMouseEnter.bind(this)}
        onMouseLeave={this.props.onMouseLeave.bind(this)}
        onFocus={this.props.onFocus.bind(this)}
        onBlur={this.props.onBlur.bind(this)}
        ref={this.ref}
        className={classNames({ [styles.menuItemActive]: this.props.active && this.props.item.children.length > 0, [styles.menuItem]: true })}
      >

        <Link
          to={'/' + (this.props.item.page.full_slug || this.props.item.page.slug)}
          onClick={this.props.onClick}
        >
          {this.props.item.title}
        </Link>

        {this.props.item.children.length > 0
          ? (
            <ul className={classNames({ [styles.subMenuActive]: this.props.active, [styles.subMenu]: true })} ref={this.subnavRef}>
              {this.props.item.children.map(child => (
                <li key={child.id} className={classNames(styles.menuItem, styles.subMenuItem)}>
                  <Link
                    to={child.page.full_slug || '/' + this.props.item.page.slug + '/' + child.page.slug}
                    onClick={this.props.onClick}
                  >
                    {child.title}
                  </Link>
                </li>
              ))}
            </ul>
            )
          : null}
      </li>
    )
  }
}

MenuItem.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.string,
    page: PropTypes.object,
    children: PropTypes.array,
    title: PropTypes.string
  }).isRequired,
  active: PropTypes.bool,
  windowWidth: PropTypes.number,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onClick: PropTypes.func,
  location: PropTypes.object
}

const mapStateToProps = (state, ownProps) => ({
  ...ownProps,
  windowWidth: state.global.windowWidth
})

export default connect(mapStateToProps)(MenuItem)
